/*******************************************************************************
 * Copyright (c) 2024 Belltane LLC
 *
 * All rights reserved.
 *
 * Contributors:
 *   Amina Rais - Initial implementation
 *
 * Version: 1.0.0
 *
 *******************************************************************************/

import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
import Container from '@mui/material/Container';


const PageSubHeader = ({ location }) => {
    const { classes } = useStyles();
    const [locationTitle, setLocationTitle] = useState('');

    useEffect(() => {
        setLocationTitle(location ? location : '')
    }, [location])
    return (
        <React.Fragment>
            <main>
                <Grid item className={classes.container} xs={12} sm={12} md={12}>
                    <div className={classes.heroContent}>
                        <Container className={classes.cardGrid} maxWidth="xl">
                            <div > 
                                <Typography className={classes.bigHeadersubtitle} variant="h5"
                                    style={{ color: "white", textTransform: 'uppercase' }} paragraph>
                                {locationTitle ? locationTitle : ''}
                                </Typography>

                            </div>
                        </Container>
                    </div>
                </Grid>
            </main>
        </React.Fragment >
    );
}

const useStyles = makeStyles({ "name": { PageSubHeader } })((theme) => ({
    root: {
        display: 'flex',
    },
    CardActions: {
        padding: '10px',
        "&:hover + $toggledElement": {
            backgroundColor: "black",
            display: "block"
        }
    },

    details: {
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        flex: '1 0 auto',
    },
    imageDescp: {
        width: '65%;',
        padding: '1%',
        transition: 'transform .2s',
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'block',
        "&:hover": {
            transform: 'scale(1.2)',

        }
    },
    imageDotedDescp: {
        width: '50%;',
        padding: '5%',
        transition: 'transform .2s',
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'block',
        "&:hover": {
            transform: 'scale(1.2)',

        }
    },
    icon: {
        marginRight: theme.spacing(2),
    },
    heroContent: {
        maxHeight: '100px',
        position: 'relative',
        zIndex: '9',
        display: 'flex',
        alignItems: 'center',
         paddingTop :'30px', 
         background: `linear-gradient(to right, #5356FF, #DFF5FF)`,
        },

    container: {

        paddingLeft: '0',
        paddingRight: '0',
        zIndex: '1',
        position: 'relative'
    },
    bigHeaderTypo: {
        fontFamily: 'Roboto',

        background: 'white',
        maxWidth: '200px',
        fontSize: '40px!important',
        lineHeight: '1.2!important',
        color: theme.palette.primary.main,
        marginBottom: '40px!important',
 
    },
    bigSubHeaderTypo: {

        fontSize: '20px!important',
        lineHeight: '1.67!important',
        color: theme.palette.primary.main,
        marginBottom: '40px!important',
        fontWeight: '500'
    },
    bigHeaderImg: {
        height: '70px',
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'block',
        color: theme.palette.primary.main,

    },
    bigHeadersubtitle: {
        fontSize: '20px!important',
         width: 'fit-content',
        color: theme.palette.primary.main,
 
    },

    heroButtons: {
        marginTop: theme.spacing(4),
    },
    cardGrid: {
        paddingTop: theme.spacing(8), 
    },
    cardService: {
        position: 'relative',
        display: 'block',
        padding: '10px 60px',
        transition: 'all .25s cubic- bezier(.645, .045, .355, 1)',
        borderRadius: '5px',
        zIndex: '99',
        backgroundColor: '#fff!important',
        "&:hover": {
            transform: 'scale(1.05)',
            boxShadow: " 0 2.8px 2.2px rgba(0, 0, 0, 0.034),0 6.7px 5.3px rgba(0, 0, 0, 0.048),0 12.5px 10px rgba(0, 0, 0, 0.06), 0 22.3px 17.9px rgba(0, 0, 0, 0.072),0 41.8px 33.4px rgba(0, 0, 0, 0.086),0 100px 80px rgba(0, 0, 0, 0.12)",

        }

    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',

        "&:hover": {
            background: '#efefef!important',
            boxShadow: " 0 2.8px 2.2px rgba(0, 0, 0, 0.034),0 6.7px 5.3px rgba(0, 0, 0, 0.048),0 12.5px 10px rgba(0, 0, 0, 0.06), 0 22.3px 17.9px rgba(0, 0, 0, 0.072),0 41.8px 33.4px rgba(0, 0, 0, 0.086),0 100px 80px rgba(0, 0, 0, 0.12)",
            borderRadius: '5px'
        },
    },
    cardMedia: {
        paddingTop: '56.25%', // 16:9
    },
    cardContent: {
        flexGrow: 1,
    },
  
    blocksTypo: {
        textAlign: 'center',
        color: '#383e56',
        paddingTop: '10px'

    },
    blocksTypoInfo: {
        textAlign: 'center',
        color: '#748494',
        paddingTop: '10px',
        fontSize: '20px!important'

    },
    divider: {
        backgroundColor: '#fb743e'
    },
    sectionTitleBorder: {
        width: '50px',
        height: '2px',
        marginRight: 'auto',
        marginLeft: 'auto',
        backgroundColor: '#fb743e',

    },
    IconsDivInfo: {
        fontSize: '2rem',

    },
    IconsDivInfoHolder: {
        width: '80px',
        padding: '20px',
        borderRadius: '50%',
        textAlign: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'block',
        background: 'white',
        color: '#206aa7',

        "&:hover": {
            background: '#206aa7',
            color: 'white',
            transform: 'rotate(360deg)',
            transition: 'width 2s, height 2s, transform 2s'

        },

    },
    list: {
        color: 'black',
        marginTop: '50px!important'
    },
    subitemIList: {
        lineHeight: '1.7!important',

        "&::before": {
            backgroundColor: '#fb743e !important',
            content: `''`,
            borderRadius: '50%',
            width: '7px',
            height: '7px',
            position: 'absolute',
            left: '0',
            top: '20px'
        },


    },
    cotainerListIfo: {
        backgroundColor: '#f8faff',
        padding: '10px'
    },
    containerWhiteBG: {
        backgroundColor: '#fff!important',
        padding: '100px',

    },
    containerDotBG: {
        backgroundColor: '#fff!important',
        padding: '10px',
        backgroundImage: 'radial-gradient(circle, #cbcbcb  20%, transparent 10%), radial-gradient(circle, #cbcbcb  20%, transparent 10%)',
        backgroundSize: '10px 10px',
        backgroundPosition: '0 0, 50px 50px'
    }
}));


export default PageSubHeader